import { createApp } from 'vue'

import Shell from './Shell.vue'

const mountElSelector = '#chat-ui'
const mountEl: HTMLElement = document.querySelector(
  mountElSelector,
) as HTMLElement

const app = createApp(Shell, { ...mountEl.dataset })
app.mount(mountElSelector)
